import type { SVGProps } from 'react'

export const Workflow = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M4.375 5.20831C5.06536 5.20831 5.625 4.64867 5.625 3.95831C5.625 3.26796 5.06536 2.70831 4.375 2.70831C3.68464 2.70831 3.125 3.26796 3.125 3.95831C3.125 4.64867 3.68464 5.20831 4.375 5.20831Z"
			stroke="currentColor"
			strokeWidth="1.25"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M15.625 17.2917C16.3154 17.2917 16.875 16.732 16.875 16.0417C16.875 15.3513 16.3154 14.7917 15.625 14.7917C14.9346 14.7917 14.375 15.3513 14.375 16.0417C14.375 16.732 14.9346 17.2917 15.625 17.2917Z"
			stroke="currentColor"
			strokeWidth="1.25"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M5.625 3.95831H15.625C16.3154 3.95831 16.875 4.5179 16.875 5.20831V8.54165C16.875 9.23206 16.3154 9.79165 15.625 9.79165H9.79167"
			stroke="currentColor"
			strokeWidth="1.25"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M11.25 7.91669L9.375 9.79169L11.25 11.6667"
			stroke="currentColor"
			strokeWidth="1.25"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M11.4585 16.6667C11.8037 16.6667 12.0835 16.3869 12.0835 16.0417C12.0835 15.6965 11.8037 15.4167 11.4585 15.4167C11.1133 15.4167 10.8335 15.6965 10.8335 16.0417C10.8335 16.3869 11.1133 16.6667 11.4585 16.6667Z"
			fill="currentColor"
		/>
		<path
			d="M9.375 16.6667C9.72018 16.6667 10 16.3869 10 16.0417C10 15.6965 9.72018 15.4167 9.375 15.4167C9.02982 15.4167 8.75 15.6965 8.75 16.0417C8.75 16.3869 9.02982 16.6667 9.375 16.6667Z"
			fill="currentColor"
		/>
		<path
			d="M7.2915 16.6667C7.63668 16.6667 7.9165 16.3869 7.9165 16.0417C7.9165 15.6965 7.63668 15.4167 7.2915 15.4167C6.94633 15.4167 6.6665 15.6965 6.6665 16.0417C6.6665 16.3869 6.94633 16.6667 7.2915 16.6667Z"
			fill="currentColor"
		/>
		<path
			d="M5.20825 16.6667C5.55343 16.6667 5.83325 16.3869 5.83325 16.0417C5.83325 15.6965 5.55343 15.4167 5.20825 15.4167C4.86307 15.4167 4.58325 15.6965 4.58325 16.0417C4.58325 16.3869 4.86307 16.6667 5.20825 16.6667Z"
			fill="currentColor"
		/>
		<path
			d="M3.125 16.6667C3.47018 16.6667 3.75 16.3869 3.75 16.0417C3.75 15.6965 3.47018 15.4167 3.125 15.4167C2.77982 15.4167 2.5 15.6965 2.5 16.0417C2.5 16.3869 2.77982 16.6667 3.125 16.6667Z"
			fill="currentColor"
		/>
		<path
			d="M3.125 14.5833C3.47018 14.5833 3.75 14.3035 3.75 13.9583C3.75 13.6131 3.47018 13.3333 3.125 13.3333C2.77982 13.3333 2.5 13.6131 2.5 13.9583C2.5 14.3035 2.77982 14.5833 3.125 14.5833Z"
			fill="currentColor"
		/>
		<path
			d="M3.125 12.5C3.47018 12.5 3.75 12.2202 3.75 11.875C3.75 11.5298 3.47018 11.25 3.125 11.25C2.77982 11.25 2.5 11.5298 2.5 11.875C2.5 12.2202 2.77982 12.5 3.125 12.5Z"
			fill="currentColor"
		/>
		<path
			d="M3.125 10.4167C3.47018 10.4167 3.75 10.1369 3.75 9.79169C3.75 9.44651 3.47018 9.16669 3.125 9.16669C2.77982 9.16669 2.5 9.44651 2.5 9.79169C2.5 10.1369 2.77982 10.4167 3.125 10.4167Z"
			fill="currentColor"
		/>
		<path
			d="M5.20825 10.4167C5.55343 10.4167 5.83325 10.1369 5.83325 9.79169C5.83325 9.44651 5.55343 9.16669 5.20825 9.16669C4.86307 9.16669 4.58325 9.44651 4.58325 9.79169C4.58325 10.1369 4.86307 10.4167 5.20825 10.4167Z"
			fill="currentColor"
		/>
		<path
			d="M7.2915 10.4167C7.63668 10.4167 7.9165 10.1369 7.9165 9.79169C7.9165 9.44651 7.63668 9.16669 7.2915 9.16669C6.94633 9.16669 6.6665 9.44651 6.6665 9.79169C6.6665 10.1369 6.94633 10.4167 7.2915 10.4167Z"
			fill="currentColor"
		/>
		<path
			d="M13.5415 16.0417H14.3748"
			stroke="currentColor"
			strokeWidth="1.25"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)
